module.exports = __webpack_public_path__ + "media/app/assets/races/pandaren_male-632db8732b7f95d20e63fff4d4ccb7ad.png";